import { render, staticRenderFns } from "./ZcjgAdd.vue?vue&type=template&id=44589c6e"
import script from "./ZcjgAdd.vue?vue&type=script&lang=js"
export * from "./ZcjgAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports